// extracted by mini-css-extract-plugin
export var attachment = "_md-a";
export var emailContainer = "_md-4";
export var emailContentPaddedContainer = "_md-b";
export var emailHeader = "_md-6";
export var emailIframe = "_md-3";
export var emailInfoIcon = "_md-9";
export var emailShortenedSummary = "_md-e";
export var infoDropdown = "_md-0";
export var infoRowBoundedContent = "_md-d";
export var internal = "_md-5";
export var merchant = "_md-8";
export var messageInputContainer = "_md-h";
export var normal = "_md-7";
export var replyCard = "_md-f";
export var subtleButton = "_md-1";
export var subtleButtonIconContainer = "_md-2";
export var toggleViewRepliesButton = "_md-c";
export var wrappingText = "_md-g";